import { GetVideoCall } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";

export const SendVideoCallNotification = {
  mixins: [],
  data() {
    return {
      GetAllViolationsList: [],
      overlay: false,
      user_type: "",
      ChatsList: [],
    };
  },
  methods: {
    async SendVideoCallMethod() {
      try {
        let result = await API.graphql(
          graphqlOperation(GetVideoCall, {
            chat_id: this.$store.getters.get_chat_id,
            video_status: "OUTGOING_CALL",
          })
        );

        // this.CreateChat = "";
        // this.scrollToBottom();
        // this.FireNotificationMethod();
      } catch (error) {
        console.log("Check error", error);
        // this.overlay = false;
      }
    },
  },
};
